import { TextField } from "@mui/material";
import { withStyles } from "@mui/styles";

export const StyledTextfield = withStyles({
  root: {
    '& label.Mui-focused': {
      color: '#fff',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#fff',
      },
      '&:hover fieldset': {
        borderColor: '#fff',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'white',
      },
    },
    width: "100%",
  },
})(TextField);